<template>
  <div class="text-card-container">
    <h2 v-if="title">{{ title }}</h2>
    <p v-if="text" class="text">
      {{ text }}
    </p>
    <div class="cta-group">
      <slot name="cta"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AW23TextCard",
  inject: ["mq"],
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-card-container {
  margin: 60px 20px 60px;
  @include respond-above(md) {
    margin: 80px 20px 80px;
  }
}
h2 {
  text-align: center;
  margin: 0 0 15px;
  @include t__editorial-headline-20;
  @include respond-above(md) {
    @include t__editorial-headline-50;
    margin: 0 0 50px;
  }
}

.text {
  margin: 0 0 30px;
  text-align: center;
  @include t__editorial-body-10;
  @include respond-above(md) {
    max-width: 800px;
    margin: 0 auto 60px;
    @include t__editorial-body-30;
  }
}

.cta-group {
  display: flex;
  column-gap: 15px;
  justify-content: center;
}
</style>
